import React from 'react';

interface TeslaRobotProps {
  className?: string;
  width?: number;
  height?: number;
}

const TeslaRobot: React.FC<TeslaRobotProps> = ({ 
  className = '', 
  width = 120, 
  height = 120 
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Head */}
      <path
        d="M60 20C49.5066 20 41 28.5066 41 39V48C41 58.4934 49.5066 67 60 67C70.4934 67 79 58.4934 79 48V39C79 28.5066 70.4934 20 60 20Z"
        fill="#1A1A1A"
      />
      
      {/* Face plate */}
      <path
        d="M60 25C52.268 25 46 31.268 46 39V48C46 55.732 52.268 62 60 62C67.732 62 74 55.732 74 48V39C74 31.268 67.732 25 60 25Z"
        fill="#2C2C2C"
      />
      
      {/* Eyes */}
      <path
        d="M52 40C53.6569 40 55 38.6569 55 37C55 35.3431 53.6569 34 52 34C50.3431 34 49 35.3431 49 37C49 38.6569 50.3431 40 52 40Z"
        fill="#00F7FF"
      />
      <path
        d="M68 40C69.6569 40 71 38.6569 71 37C71 35.3431 69.6569 34 68 34C66.3431 34 65 35.3431 65 37C65 38.6569 66.3431 40 68 40Z"
        fill="#00F7FF"
      />
      
      {/* Neck */}
      <rect x="55" y="67" width="10" height="5" fill="#1A1A1A" />
      
      {/* Body */}
      <path
        d="M45 72H75C77.7614 72 80 74.2386 80 77V95C80 97.7614 77.7614 100 75 100H45C42.2386 100 40 97.7614 40 95V77C40 74.2386 42.2386 72 45 72Z"
        fill="#1A1A1A"
      />
      
      {/* Chest plate */}
      <path
        d="M50 77H70C71.1046 77 72 77.8954 72 79V93C72 94.1046 71.1046 95 70 95H50C48.8954 95 48 94.1046 48 93V79C48 77.8954 48.8954 77 50 77Z"
        fill="#2C2C2C"
      />
      
      {/* Arms */}
      <rect x="30" y="72" width="10" height="25" rx="5" fill="#1A1A1A" />
      <rect x="80" y="72" width="10" height="25" rx="5" fill="#1A1A1A" />
      
      {/* Hands */}
      <rect x="28" y="97" width="14" height="5" rx="2.5" fill="#2C2C2C" />
      <rect x="78" y="97" width="14" height="5" rx="2.5" fill="#2C2C2C" />
      
      {/* Legs */}
      <rect x="50" y="100" width="8" height="20" rx="4" fill="#1A1A1A" />
      <rect x="62" y="100" width="8" height="20" rx="4" fill="#1A1A1A" />
      
      {/* Feet */}
      <path
        d="M48 120H60C60 117.791 58.2091 116 56 116H52C49.7909 116 48 117.791 48 120Z"
        fill="#2C2C2C"
      />
      <path
        d="M60 120H72C72 117.791 70.2091 116 68 116H64C61.7909 116 60 117.791 60 120Z"
        fill="#2C2C2C"
      />
      
      {/* Glowing effect */}
      <circle cx="52" cy="37" r="3" fill="#00F7FF" opacity="0.5">
        <animate 
          attributeName="opacity" 
          values="0.5;0.8;0.5" 
          dur="2s" 
          repeatCount="indefinite" 
        />
      </circle>
      <circle cx="68" cy="37" r="3" fill="#00F7FF" opacity="0.5">
        <animate 
          attributeName="opacity" 
          values="0.5;0.8;0.5" 
          dur="2s" 
          repeatCount="indefinite" 
        />
      </circle>
      
      {/* Chest light */}
      <circle cx="60" cy="85" r="3" fill="#00F7FF" opacity="0.7">
        <animate 
          attributeName="opacity" 
          values="0.7;1;0.7" 
          dur="3s" 
          repeatCount="indefinite" 
        />
      </circle>
    </svg>
  );
};

export default TeslaRobot;
